export const SPEC_ORDER = [
  'aeResourceLevel',
  'projectHealth',
  'aeNotes',
  'projectWaiver'
]


